export function includesEnum<T extends string, U extends T>(item: T, items: U[]) {
  return (items as string[]).includes(item);
}
